module.exports = __webpack_public_path__ + "img/BedOutlined.2ca97730.svg";